import { createApi } from "@reduxjs/toolkit/query/react";
import { privateBaseQuery } from "@/api/base/private/privateBaseQuery";

export type PaymentProvider = {
  id: number;
  name?: string | null;
  description?: string | null;
  logo?: string | null;
  type?: string | null;
};

export const paymentProvidersApi = createApi({
  reducerPath: "paymentProvidersApi",
  baseQuery: privateBaseQuery(),
  tagTypes: ["PaymentProviders"],
  endpoints: (builder) => ({
    getPaymentProviders: builder.query<PaymentProvider[], void>({
      query: () => ({
        url: "/payment-providers",
        method: "GET",
      }),
      transformResponse: (response: any) => {
        // Прямой массив
        if (Array.isArray(response)) return response;
        
        // Формат с пагинацией: response.entities.data
        if (response?.entities?.data && Array.isArray(response.entities.data)) {
          return response.entities.data;
        }
        
        // Альтернативный формат с пагинацией: response.data.entities.data
        if (response?.data?.entities?.data && Array.isArray(response.data.entities.data)) {
          return response.data.entities.data;
        }
        
        // Без пагинации: response.data.entities
        if (Array.isArray(response?.data?.entities)) return response.data.entities;
        
        // Альтернативные форматы
        if (Array.isArray(response?.entities)) return response.entities;
        if (Array.isArray(response?.data)) return response.data;
        
        return [];
      },
      providesTags: [{ type: "PaymentProviders", id: "LIST" }],
    }),
  }),
});

export const { useGetPaymentProvidersQuery } = paymentProvidersApi;
